import type { CartPaymentResponseDto, PaymentProfileDto } from "@sticker-giant/sg-frontend-common";
import { TransactionResultEnum } from "@sticker-giant/sg-frontend-common";
import { CustomerFacingErrorMessages } from "@/constants/CustomerFacingErrorMessages";

interface CreditCardPaymentInput {
  paymentToken: string | undefined;
  savedCard: PaymentProfileDto | undefined;
  saveCard: boolean;
}

// Pay with the new card if entered, otherwise the saved card.
// Undefined if neither.
export function resolveCreditCardPayment({ paymentToken, savedCard, saveCard }: CreditCardPaymentInput) {
  if (paymentToken) return { paymentToken, savePaymentMethod: saveCard };
  if (savedCard) return { paymentProfileId: savedCard.paymentProfileId };
  return undefined;
}

export type FinalizeAction =
  | { kind: "success" }
  | { kind: "declined"; message: string }
  | { kind: "processing"; message: string };

export function mapFinalizeResponse(res: CartPaymentResponseDto | undefined): FinalizeAction {
  const result = res?.transactionDetails?.result;

  if (result === TransactionResultEnum.SUCCESS) {
    return { kind: "success" };
  }

  if (result === TransactionResultEnum.FAILURE) {
    return { kind: "declined", message: CustomerFacingErrorMessages.paymentMethodDeclined };
  }

  // Defensive default — covers PROCESSING_ERROR, undefined response, missing transactionDetails, and unknown results.
  return { kind: "processing", message: CustomerFacingErrorMessages.paymentProcessing };
}
